import React from "react";
import {
  AppStoreDownloadLink,
  FooterStaticData,
  Images,
  PlayStoreDownloadLink,
} from "../../utils/constant";
import "./style.css";
import { useDeviceType } from "../../utils/isMobileHook";

const Footer = () => {
  const { isMobile } = useDeviceType();
  return (
    <section className="footer-container">
      <div className="download-card">
        <div className="download-card-heading-container">
          <h3 className="download-card-heading">
            Download <span className="bold-heading">DiveBuddies</span> for free
          </h3>
          <div className="download-sub-card-container">
            {FooterStaticData.cards.map((card, index) => (
              <div key={index} className="download-sub-card-item">
                <img
                  src={card.icon}
                  alt={card.text}
                  className="download-sub-card-icon"
                />
                <p className="download-sub-card-text">{card.text}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="footer-download-button-container">
          <a
            href={PlayStoreDownloadLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={Images.playStoreBtn}
              alt="play store download button"
              className="footer-download-button"
            />
          </a>
          <a
            href={AppStoreDownloadLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={Images.appStoreBtn}
              alt="app store download button"
              className="footer-download-button"
            />
          </a>
        </div>
      </div>

      <div className="white-box"></div>
      <div className="triangle"></div>

      <div className="footer-content-container">
        <div className="footer-inner-container">
          <a href="#home">
            <img
              src={Images.logo}
              alt="dive buddies logo"
              className="footer-logo"
            />
          </a>
          <div className="footer-items-container">
            <img src={Images.dotImage} alt="dot" className="footer-dot-image" />
            {FooterStaticData.footerLinks.map((item, index) => (
              <div
                className="footer-item"
                style={{
                  borderLeft:
                    index !== 0 && !isMobile ? "0.6px solid #BFC4CA" : "none",
                }}
                key={index}
              >
                <h5 className="footer-links-heading">{item.heading}</h5>
                <span className="footer-line"></span>
                <div className="footer-links-container">
                  {item.links.map((link, linkIndex) => (
                    <a
                      className="footer-links"
                      key={linkIndex}
                      href={link.link}
                      target={link.blank ? "_blank" : "_self"}
                      rel={link.blank ? "noopener noreferrer" : ""}
                    >
                      {link.text}
                    </a>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="footer-copyright-container">
          <span className="copyright-border-line"></span>
          <div className="copyright-inner-container">
            <p className="copyright-text">{FooterStaticData.copyRight}</p>
            <p className="copyright-text">
              {FooterStaticData.allRightReserved}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
